import React from 'react'
import {molabsStyles} from "../../styles";
import List from '@material-ui/core/List';
import Page from "../../components/page";
import {gql} from "@apollo/client/core";
import {Grid, Typography} from "@material-ui/core";
import JobListItem from "../../components/job/JobListItem";
import Button from "@material-ui/core/Button";
import NextLink from 'next/link'
import {createApolloClient} from "../../client/apollo";
import {FormattedMessage, useIntl} from "react-intl";
import Throw404 from "../../components/Throw404";

const GET_ACTIVE_JOBS = gql`
    query getActiveJobs {
        getActiveJobs {
            slug
        }
    }
`;

const GET_ACTIVE_JOB = gql`
    query getActiveJob($slug: String!) {
        getActiveJob(
            slug: $slug
        ) {
            slug
            title
            image
            description
            projects
        }
    }
`;

function JobDetail({job}) {
    const classes = molabsStyles();
    const intl = useIntl();
    const image = require('../../images/jobhero.png?resize&sizes[]=1216&sizes[]=960&sizes[]=600&sizes[]=200');
    const webp = require('../../images/jobhero.png?resize&sizes[]=1216&sizes[]=960&sizes[]=600&sizes[]=200&format=webp');
    const openGraph = {
        images: [{
            url: image.src,
            width: 1858,
            height: 929,
        }]
    }

    if (!job) {
        return (<Throw404/>);
    }

    return (
        <Page
            image={image}
            webp={webp}
            title={job ? job.title : intl.formatMessage({id: 'jobs_title'})}
            description={job ? job.description : intl.formatMessage({id: 'jobs_desc'})}
            metaTitle={job ? job.title : intl.formatMessage({id: 'jobs_title'})}
            hideFeaturedPostContent={true}
            openGraph={openGraph}>
                <div className={classes.contentContainer}>
                    <Typography variant={"h2"} gutterBottom>{job.title}</Typography>
                    <Typography color={"secondary"} paragraph>
                        Start your fully remote work life or take it to the next level.
                        Choose your salary, weekly hours, vacation days and work (almost) whenever you want.<br/>
                        You will work in a trust based and result orientated positive environment. No boss breathing down your neck.<br/>
                    </Typography>
                    <Typography color={"secondary"} paragraph>
                        For now it would only be you and me, but with increasing demand more people will join.<br/>
                        No client contact needed, only if you want. Twice a year I'll organise a workation.
                    </Typography>
                    <Typography variant={"h2"} className={classes.subHeadline}>Projects you could be working on</Typography>
                    <List>
                        { job.projects.map((project, key) => (
                            <JobListItem key={key} text={project} />
                        ))}
                    </List>
                    <NextLink href={"/job/[slug]/apply"} as={"/job/" + job.slug + "/apply"} passHref>
                        <Button variant={"contained"}>
                            <FormattedMessage id="jobs_apply_now"/>
                        </Button>
                    </NextLink>
                    <Grid container>
                        <Grid item xs={12} md={6}>
                            <Typography variant={"h2"} className={classes.subHeadline}>Frontend-Stack</Typography>
                            <List>
                                <JobListItem text="React" />
                                <JobListItem text="Next.js" />
                                <JobListItem text="Material UI" />
                                <JobListItem text="TypeScript" />
                                <JobListItem text="Formik + yup" />
                                <JobListItem text="jQuery/Bootstrap (Legacy)" />
                            </List>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant={"h2"} className={classes.subHeadline}>Backend-Stack</Typography>
                            <List>
                                <JobListItem text="Symfony 3/5" />
                                <JobListItem text="Doctrine + MySQL" />
                                <JobListItem text="RabbitMQ" />
                                <JobListItem text="Redis" />
                                <JobListItem text="Guzzle" />
                                <JobListItem text="REST/GraphQL APIs" />
                            </List>
                        </Grid>
                    </Grid>
                    <Typography variant={"h2"} className={classes.subHeadline}>About Us</Typography>
                    <Typography color={"secondary"} paragraph>
                        My name is Moritz, born in Germany and traveling around the world as a digital nomad.<br/>
                        4 years ago I shifted from working on contracts to sourcing my own clients and helping them with there long term projects and goals.<br/>
                        The company is based in Bulgaria.
                    </Typography>
                </div>
        </Page>
    );
}

export const getStaticPaths = async ({locales}) => {
    const client = createApolloClient();
    const {data} = await client.query({
        query: GET_ACTIVE_JOBS
    });
    const paths = [];

    data.getActiveJobs.map(job => {
        locales.map(locale => {
            paths.push({ params: { slug: job.slug }, locale})
        })
    });

    return {
        paths,
        fallback: false,
    }
}

export const getStaticProps = async ({ params }) => {
    const client = createApolloClient();
    const {data} = await client.query({
        query: GET_ACTIVE_JOB,
        variables: {
            slug: params.slug,
        }
    });

    return {
        props: {
            job: data.getActiveJob
        },
        revalidate: 1800,
    };
};

export default JobDetail;
